<template>
  <div class="sidebar">
    <Select class="select" v-model="defaultVersion" @on-change="change">
      <Option
        v-for="item in versionItems"
        :value="item.version"
        :key="item.version"
      >{{ item.version }}</Option>
    </Select>

    <nav>
      <div :class="'level level' + menu.depth + (menu.id === 1 ? ' active' : '')" v-for="menu in menus" :key="menu.id">
        <template v-if="menu.request">
          <template v-if="menu.full">
            <a @click="changeToDocument(menu, $event)">{{ menu.text }}</a>
          </template>
          <template v-else>
            <a class="unset">{{ menu.text.replace(/[^\w\s]+/, ':') }}</a>
          </template>
        </template>
        <template v-else>
          <a :href="'#' + menu.id" @click="activeMenu($event)">{{ menu.text }}</a>
        </template>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { parse } from "@/util/browser_params";
import _first from "lodash/first";
import _filter from "lodash/filter";

export default {
  name: "DocumentMenu",
  data() {
    return {
      defaultVersion: "",
      browserVersion: "",
      browserHasSubFolder: false,
      browserText: ""
    };
  },
  created() {
    let { version, hasSubFolder, text } = parse();
    hasSubFolder = !!hasSubFolder;
    this.browserVersion = version;
    this.browserHasSubFolder = hasSubFolder;
    this.browserText = text;
    this.resetBrowserParam();
  },
  methods: {
    changeToDocument(menu, target) {
      this.activeMenu(target)
      this.$store.dispatch("document/backToTop");
      let pathTtem = {
        version: this.defaultVersion,
        path: menu.full
      };
      this.$store.dispatch("document/getDocumentByPath", pathTtem).then(() => {
        this.$store.dispatch("document/setLoading", false);
      });
    },
    change(version) {
      this.$store.dispatch("document/backToTop");
      this.getDocumentByVersion(this.getVersionItemByVersion(version));
    },
    getVersionItemByVersion(version) {
      return this.versionItems.find(item => item.version === version);
    },
    getDocumentByVersion(versionItem) {
      this.$store.dispatch("document/setLoading", true);
      if (versionItem.hasSubFolder) {
        // web
        this.$store.dispatch("document/getMenusFullPathByVersion", versionItem);
      } else {
        // ios, android
        this.$store.dispatch("document/getDocumentByVersion", versionItem).then(() => {
          this.$store.dispatch("document/setLoading", false);
        });
      }
    },
    mockClickJumpByText(text) {
      setTimeout(() => {
        this.$el.querySelectorAll(".level a").forEach(elm => {
          if (elm.textContent === decodeURI(text)) {
            elm.dispatchEvent(new MouseEvent("click"));
          }
        });
      });
    },
    resetBrowserParam() {
      history.pushState(null, null, window.location.pathname);
    },
    activeMenu(dom) {
      if (dom) {
        const $active = this.$el.querySelector(".level.active");
        if ($active) {
          $active.classList.remove("active");
        }
        const $parent = dom.srcElement.parentElement;
        $parent.classList.add("active");
      }
    }
  },
  computed: {
    ...mapState({
      menus: state => state.document.menus
    }),
    ...mapGetters("document", {
      firstVersionItem: "getFirstVersion",
      versionItems: "getVersions"
    })
  },
  watch: {
    firstVersionItem() {
      if (this.browserVersion) {
        this.defaultVersion = this.browserVersion;
        this.getDocumentByVersion({
          version: this.browserVersion,
          hasSubFolder: this.browserHasSubFolder
        });
      } else {
        // init
        this.defaultVersion = this.firstVersionItem.version;
        this.getDocumentByVersion(this.firstVersionItem);
      }
    },
    menus() {
      if (this.menus.length) {
        const menus = _filter(this.menus, menu => menu.depth === 2);
        const first = _first(menus);
        if (first && first.request) {
          this.changeToDocument(first);
        }
        if (this.browserVersion && this.browserText) {
          this.mockClickJumpByText(this.browserText);
        }
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.sidebar {
  height: 100vh;
  position: absolute;
  overflow: auto;
  width: 256px;
  padding-top: 100px;
  border-right: 3px solid rgba(118, 120, 122, 0.3);
  padding-right: 20px;
}
.select {
  width: 150px;
  margin-left: 20px;
  margin-bottom: 20px;
}
a {
  color: #7e7e7e;
}
a:hover {
  color: #c51586;
}
.level {
  font-size: 14px;
  margin: 5px 5px 5px 10px;
  padding-left: 15px;
}
.level::before {
  content: "";
  width: 5px;
  height: 5px;
  background: #7e7e7e;
  position: absolute;
  margin-top: 7px;
  margin-left: -10px;
  border: 1px solid #7e7e7e;
  border-radius: 50%;
}
.level2 {
  margin-left: 20px;
}
.level2::before {
  background: white;
}
.level3 {
  margin-left: 40px;
}
.level3::before {
  border-radius: 0;
}
.unset {
  cursor: unset;
}
.active {
  background-color: #f1f1f1;
}
</style>
